<div class="form-group row form-field-material-switch">
    <div class="col-48">
        <div class="material-switch-container"
             [attr.data-test]="'switch-' + (name | e2eAttributeEncoding) + '-div'"
             role="button"
             (click)="onClick()"
             tabindex="0"
             [attr.aria-checked]="isChecked()">
            <div class="material-switch">
                <input [(ngModel)]="_value"
                       [attr.data-test]="'switch-' + (name | e2eAttributeEncoding) + '-input'"
                       [name]="name"
                       [attr.id]="name"
                       type="checkbox"
                       [checked]="isChecked()"
                       (change)="onInputChange($event)"/>

                <div class="handle" [ngClass]="color"></div>
            </div>
        </div>
    </div>
</div>
